/*
 *
 * Furniture constants
 *
 */

import { API_BASE_URL } from 'containers/App/constants';

enum ActionTypes {
  FURNITURE_ADD_CABINET = 'app/CONFIGURATOR/FURNITURE/FURNITURE_ADD_CABINET',
  FURNITURE_SELECT_CABINET = 'app/CONFIGURATOR/FURNITURE/FURNITURE_SELECT_CABINET',
  FURNITURE_SELECT_FROMID_CABINET = 'app/CONFIGURATOR/FURNITURE/SELECT_FROMID_CABINET',
  FURNITURE_REMOVE_CABINET = 'app/CONFIGURATOR/FURNITURE/FURNITURE_REMOVE_CABINET',
  SELECT_FURNITURE = 'app/CONFIGURATOR/FURNITURE/SELECT_FURNITURE',
  FURNITURE_UPDATE_SUCCESS = 'app/CONFIGURATOR/FURNITURE/UPDATE_SUCCESS',
  FURNITURE_RESTORE_STEP = 'app/CONFIGURATOR/FURNITURE/RESTORE_STEP',
  FURNITURE_REORDERING = 'app/CONFIGURATOR/FURNITURE/REORDERING',
  FURNITURE_RENAME = 'app/CONFIGURATOR/FURNITURE/RENAME',
  DISPLAY_FURNITURE_REQUEST = 'app/CONFIGURATOR/FURNITURE/DISPLAY_FURNITURE',
  FURNITURE_SET_IMAGE = 'app/CONFIGURATOR/FURNITURE/SET_IMAGE',

  FURNITURE_LOAD_REQUEST = 'app/CONFIGURATOR/FURNITURE/LOAD_REQUEST',
  FURNITURE_LOAD_SUCCESS = 'app/CONFIGURATOR/FURNITURE/LOAD_SUCCESS',
  FURNITURE_LOAD_FAILURE = 'app/CONFIGURATOR/FURNITURE/LOAD_FAILURE',
  CABINET_LOAD_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_LOAD_REQUEST',
  CABINET_LOAD_SUCCESS = 'app/CONFIGURATOR/FURNITURE/CABINET_LOAD_SUCCESS',
  CABINET_LOAD_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_LOAD_FAILURE',
  CABINET_UPDATE_SUCCESS = 'app/CONFIGURATOR/FURNITURE/CABINET_UPDATE_SUCCESS',
  CABINET_RESTORE = 'app/CONFIGURATOR/FURNITURE/RESTORE',

  CABINET_ADD_SHELF = 'app/CONFIGURATOR/FURNITURE/ADD_SHELF',
  CABINET_REMOVE_SHELF_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_REMOVE_SHELF_REQUEST',

  CABINET_WIDTH_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_WIDTH_REQUEST',
  CABINET_WIDTH_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_WIDTH_FAILURE',

  CABINET_DEPTH_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_DEPTH_REQUEST',
  CABINET_DEPTH_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_DEPTH_FAILURE',

  CABINET_CORNER_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_CORNER_REQUEST',
  CABINET_CORNER_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_CORNER_FAILURE',

  CABINET_SUPPORT_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_SUPPORT_REQUEST',
  CABINET_SUPPORT_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_SUPPORT_FAILURE',

  CABINET_SHELFS_HEIGHT_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELFS_HEIGHT_REQUEST',
  CABINET_SHELFS_HEIGHT_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELFS_HEIGHT_FAILURE',

  CABINET_SWITCH_SHELF_REQUEST = 'app/CONFIGURATOR/FURNITURE/CABINET_SWITCH_SHELF_REQUEST',
  CABINET_SWITCH_SHELF_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_SWITCH_SHELF_FAILURE',

  CABINET_SHELF_SET_COMPOSITION = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELF_SET_COMPOSITION',
  CABINET_SHELF_SET_COMPOSITION_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELF_SET_COMPOSITION_FAILURE',

  CABINET_SHELF_ADD_PIECE = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELF_ADD_PIECE',
  CABINET_SHELF_ADD_PIECE_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_SHELF_ADD_PIECE_FAILURE',

  CABINET_DRAWERS_COMBINATION = 'app/CONFIGURATOR/FURNITURE/CABINET_DRAWERS_COMBINATION',
  CABINET_DRAWERS_COMBINATION_FAILURE = 'app/CONFIGURATOR/FURNITURE/CABINET_DRAWERS_COMBINATION_FAILURE',

  NAVIGATE_SHELVES = 'app/CONFIGURATOR/FURNITURE/NAVIGATE_SHELVES',
}

export const CABINET_URL = `${API_BASE_URL}/cabinet`;
export const FURNITURE_URL = `${API_BASE_URL}/furniture`;

export const BASE_CABINET = '88780056';
export const BASE_TRIPLE_SHELF_CABINET = '66141064';
export const BASE_WARDROBE_CABINET = '101055004';
export const BASE_SHOWCASE_CABINET = '159794059';
export const BASE_SHELF_CABINET = '41331393';
export const BASE_HANG_CABINET = '83973506';

export default ActionTypes;
